import React from 'react'
import LegalDocumentsFirstSection from './LegalDocumentsFirstSection'
import LegalDocumentsSecondSection from './LegalDocumentsSecondSection.js'

function LegalDocuments() {
    return (
        <div>
            <LegalDocumentsFirstSection />
            <LegalDocumentsSecondSection />
        </div>
    )
}

export default LegalDocuments
